let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gJ052")).then(() => parcelRequire('7zTBI'));